import React from 'react'

function Plates ({ className, fill }) {
  return (
    <svg fill={fill} className={className} viewBox='0 0 24 24'>
      <path d='M12,5a.47.47,0,1,0,.47.47h0A.47.47,0,0,0,12,5Z' />
      <path d='M23.53,20.11H21.45a7.05,7.05,0,0,0,2.47-2.23.47.47,0,0,0-.13-.65.48.48,0,0,0-.26-.07h-.86A11.34,11.34,0,0,0,24,12,12.21,12.21,0,0,0,
                12,0,12.21,12.21,0,0,0,0,12a11.34,11.34,0,0,0,1.33,5.16H.47a.47.47,0,0,0-.47.47.5.5,0,0,0,.08.26,7.18,7.18,0,0,0,2.46,2.22H.47a.47.47,0,0,0-.47.47.5.5,0,
                0,0,.08.26A7.41,7.41,0,0,0,6,24H18a7.45,7.45,0,0,0,5.93-3.16.47.47,0,0,0-.13-.65A.5.5,0,0,0,23.53,20.11ZM.94,12A11.2,11.2,0,0,1,12,.94,11.2,11.2,0,0,1,
                23.06,12a10.56,10.56,0,0,1-1.45,5.16H19.27A8.84,8.84,0,0,0,21.05,12a9.18,9.18,0,0,0-9-9A9.18,9.18,0,0,0,3,12a8.84,8.84,0,0,0,1.78,5.16H2.39A10.56,10.56,
                0,0,1,.94,12Zm17.13,5.16H5.93a8,8,0,0,1-2-5.16A8.23,8.23,0,0,1,12,3.89,8.23,8.23,0,0,1,20.11,12,8,8,0,0,1,18.07,17.16Zm-16.63.93H22.56a6.59,6.59,0,0,
                1-4.56,2H6A6.63,6.63,0,0,1,1.44,18.09Zm16.56,5H6a6.59,6.59,0,0,1-4.57-2H22.56a6.54,6.54,0,0,1-4.56,2Z'
      />
      <path d='M14,5.26a.45.45,0,0,0-.58.31.48.48,0,0,0,.31.59h0A6.11,6.11,0,0,1,18.09,12a.48.48,0,0,0,.48.47A.47.47,0,0,0,19,12,7,7,0,0,0,14,5.26Z' />
    </svg>
  )
}

Plates.defaultProps = {
  className: 'w-full h-full',
  fill: 'currentColor'
}

export default Plates
